import React from 'react';
import propTypes from '@styled-system/prop-types';

import BaseContainer from '../base';

const FluidContainer = React.forwardRef((props, ref) => {
    return <BaseContainer className={props.className} ref={ref} display="flex" width="100%" {...props} />;
});

FluidContainer.propTypes = {
    ...propTypes.color,
    ...propTypes.space,
    ...propTypes.layout,
    ...propTypes.flexbox,
    ...propTypes.shadow,
    ...propTypes.position,
};

export default FluidContainer;
